<div
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module links-module"
>
  <div class="links__inner">
    <h3 class="links__title" *ngIf="module.title">{{ module.title }}</h3>
    <div class="links__text" *ngIf="module.text">
      <app-wysiwyg-content [content]="module.text"></app-wysiwyg-content>
    </div>
    <ul
      class="links__list list--links"
      [attr.data-total]="module.links.length"
      [attr.data-type]="module.type"
    >
      <li class="links__item" *ngFor="let link of module.links">
        <a
          *ngIf="link.typeLink === 'anchor'"
          [href]="link.url"
          (click)="onAnchorClick($event)"
          class="links__link"
         >
          {{ link.text }}
        </a>
        <a
          *ngIf="link.typeLink === 'internal'"
          [routerLink]="link.url"
          class="links__link"
         >
          {{ link.text }}
        </a>
        <a
          *ngIf="link.typeLink === 'external'"
          [href]="link.url"
          target="_blank"
          class="links__link"
         >
          {{ link.text }}
        </a>
      </li>
    </ul>
  </div>
</div>
